import { LoadableAfterPaint } from '@confluence/loadable';

export const PopupPreview = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-PopupPreview" */ '../src/PopupPreview'))
			.PopupPreview,
});
